import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

// Validate unique fields (email, mobile)
export const validateUniqueFields = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/validate-unique-fields`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Send email verification OTP
export const sendEmailOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/send-verification-otp`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Verify email OTP
export const verifyEmailOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/verify-email-otp`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Register new user
export const register = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Login user
export const login = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Logout user
export const logout = async () => {
  try {
    const response = await axios.post(`${API_URL}/auth/logout`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Check authentication status
export const checkAuth = async () => {
  try {
    const response = await axios.get(`${API_URL}/auth/check`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Refresh access token
export const refreshToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/auth/refresh-token`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Check if email exists
export const checkEmailExists = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/check-email-exists`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Reset password
export const resetPassword = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/reset-password`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Unlock account
export const unlockAccount = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/unlock-account`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Sub-User First-Time Login APIs

// Send OTP to sub-user email
export const sendSubUserOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/sub-user/send-otp`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Verify sub-user OTP
export const verifySubUserOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/sub-user/verify-otp`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Set password for sub-user
export const setSubUserPassword = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/auth/sub-user/set-password`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export default {
  validateUniqueFields,
  sendEmailOTP,
  verifyEmailOTP,
  register,
  login,
  logout,
  checkAuth,
  refreshToken,
  checkEmailExists,
  resetPassword,
  unlockAccount,
  sendSubUserOTP,
  verifySubUserOTP,
  setSubUserPassword
};
